export interface AddictionalMenuItem {
  title: string;
  iconCls:string;
  url:string;
}
